<template v-if="selectedBusiness.length > 0">
  <Modal v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">分配商机</div>
    <Form :model="formData" :label-width="100"  :rules="formRules" ref="formData">
      <FormItem label="项目">
        <Input :disabled="true" v-model="projectName" class="item-width" :number="true"></Input>
      </FormItem>
      <FormItem label="分配商机数量">
        <Input :disabled="true" v-model="count" class="item-width" :number="true"></Input>
      </FormItem>
      <FormItem label="分配给ZO" prop="zoId">
        <Select v-model="formData.zoId" class="item-width" placeholder="请选择" @on-change="test">
          <Option v-for="item in zoList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script type="text/ecmascript-6">
  import { getProjectZos } from 'api/common'
  import { allocateBusiness } from 'api/business'
  import {getProjectZosByCityCodeOrProjectFid} from "../../../../api/common";

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    projectFid:{
      type:String,
      default:''
    },
    cityCode:{
      type:String,
      default:''
    },
    projectName: {
      type: String,
      default:''
    },
    count: {
      type:Number,
      default:0
    },
    selectedBusiness: {
      type:Array,
      default:() => {
        return []
      }
    }

  },
  components: {

    },
  data () {
  return {
    show:false,
    loading:true,
    zoList:[],
    formData:{
      zoId:''
    },
    formRules:{
      zoId:[{ required: true, message: '请选择管家' ,trigger: 'change', type:'string'}]
    }
 };
 },
 watch:{
   n(val){
     this.$refs['formData'].resetFields();
     this.getZos()
     this.show = true;
   },
   // projectFid(val) {
   //
   // }
 },
 methods:{
    getZos(){
      let params={
        "cityCode": this.cityCode,
        "projectFid": this.projectFid
      }
      getProjectZosByCityCodeOrProjectFid(params).then( res => {
        this.zoList = res.data
      })

    },
   test(val){
     console.log(val)
   },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    getZoList(){

    },
    getZoName(id) {
      let zo = this.zoList.find( item => {
        return item.value === id
      })

        return zo.text
      },
      save(){
        this.$refs['formData'].validate( bool => {
          if(bool){
            let zoId = this.formData.zoId
            allocateBusiness(this.selectedBusiness,zoId,this.getZoName(zoId)).then( res=> {
              this.$Message.success('商机分配成功');
              this.changeLoading()
              this.$emit('refresh')
              this.show=false
            }).catch( () => {
              this.changeLoading()
              return
            })
          }else{
            this.changeLoading()
            return
          }
        })
      }
    }
  }
</script>
